import { useEffect, useMemo, useState } from "react";
import { useDismiss } from "../v6common/a11y";

// 사진 추가 창(계약 §4-4 attachments): 고른 사진마다 설명(50자)을 달아 한 번에 올린다.
// 직원이 올린 사진·설명은 가맹점주 앱에도 보인다 — 창 안에 그 안내를 둔다.
const CAPTION_MAX = 50;

export default function PhotoAddModal({ files: initial, maxFiles, busy, onSubmit, onClose }) {
    const [files, setFiles] = useState(initial);
    const [caps, setCaps] = useState(() => initial.map(() => ""));
    const dismiss = useDismiss(onClose);
    const previews = useMemo(() => files.map((f) => URL.createObjectURL(f)), [files]);
    useEffect(() => () => previews.forEach((u) => URL.revokeObjectURL(u)), [previews]);

    const remove = (i) => { setFiles((p) => p.filter((_, j) => j !== i)); setCaps((p) => p.filter((_, j) => j !== i)); };
    const add = (picked) => {
        const room = Math.max(0, maxFiles - files.length);
        const next = picked.slice(0, room);
        setFiles((p) => [...p, ...next]); setCaps((p) => [...p, ...next.map(() => "")]);
    };

    return (
        <div className="modal on" {...dismiss}>
            <div className="mbox" style={{ width: 560 }} onClick={(e) => e.stopPropagation()}>
                <div className="mh"><h3>사진 추가</h3><span style={{ color: "var(--tx3)", fontSize: 12.5 }}>최대 {maxFiles}장 · 장당 10MB</span>
                    <button className="btn btn-ghost btn-sm x" onClick={onClose} aria-label="닫기"><i className="fa-solid fa-xmark"></i></button></div>
                <div className="mb">
                    <div className="note" style={{ margin: "0 0 10px" }}><i className="fa-solid fa-mobile-screen"></i> 올린 사진과 설명은 <b>가맹점주에게도 보입니다</b>. 가맹점주가 봐도 되는 사진만 올려 주세요.</div>
                    {files.length === 0 && <div className="empty">사진을 골라 주세요</div>}
                    {files.map((f, i) => (
                        <div key={`${f.name}-${i}`} className="row" style={{ alignItems: "center", gap: 10, marginBottom: 10 }}>
                            <div className="img" style={{ width: 72, height: 72, flex: "none" }}><img src={previews[i]} alt="" /></div>
                            <input className="inp" style={{ flex: 1 }} aria-label={`사진 ${i + 1} 설명`} placeholder="설명(선택) · 예: 교체 후" maxLength={CAPTION_MAX}
                                value={caps[i]} onChange={(e) => setCaps((p) => p.map((c, j) => (j === i ? e.target.value : c)))} />
                            <button className="btn btn-sm btn-ghost" type="button" aria-label={`사진 ${i + 1} 빼기`} onClick={() => remove(i)}><i className="fa-solid fa-xmark"></i></button>
                        </div>
                    ))}
                    {files.length < maxFiles && (
                        <label className="btn btn-sm" style={{ cursor: "pointer" }}><i className="fa-solid fa-plus"></i>사진 더 고르기
                            <input type="file" accept="image/*" multiple hidden onChange={(e) => { add(Array.from(e.target.files)); e.target.value = ""; }} /></label>
                    )}
                </div>
                <div className="mf"><button className="btn" onClick={onClose}>취소</button>
                    <button className="btn btn-pri" disabled={busy || !files.length} onClick={() => onSubmit(files, caps)}><i className="fa-solid fa-upload"></i>올리기 ({files.length}장)</button></div>
            </div>
        </div>
    );
}
